import QuoteDetails from "../../QuoteDetails/QuoteDetails";
import { useQuoteContext } from "../../../contexts/QuoteContext/QuoteContext";
import ErrorComponentWrapper from "../../ErrorHandling/ErrorComponentWrapper";
import { useQuoteDetailsContext } from "../../../contexts/QuoteDetailsContext";
import { ErrorCode, ErrorDetails, QuotePaymentStatus } from "../../../Common/Types";
import React, { useEffect, useState } from "react";
import { QuoteCardWithTitle } from "../../QuoteList/QuoteCard/QuoteCardWithTitle";
import { useDatasources } from "../../../contexts/StoryblokContext/StoryblokContext";
import { LabelKey } from "../../../Common/StoryblokTypes";
import { getPaidQuote } from "../../../Common/services/QuoteService";

const QuotePage: React.FC = () => {
  const { selected, setupError, quotes } = useQuoteContext();
  const { quoteDraft, loadingQuoteError, loadingQuote } = useQuoteDetailsContext();
  const { labels } = useDatasources();
  const [paymentPageError, setPaymentPageError] = useState<ErrorDetails | undefined>(undefined);
  const paidOrReservedQuote = getPaidQuote(quotes);

  useEffect(() => {
    if (selected?.quoteData.status === QuotePaymentStatus.Canceled) {
      setPaymentPageError({
        code: ErrorCode.QuoteIsCancelled,
        hideAdditionalDetails: true,
        details: {
          fallbackMessage: "Since another quote has been paid or reserved, this quote automatically expired.",
        },
      });
    } else {
      setPaymentPageError(undefined);
    }
  }, [selected]);

  return (
    <ErrorComponentWrapper
      errorFooter={
        paymentPageError?.code === ErrorCode.QuoteIsCancelled && (
          <QuoteCardWithTitle quote={paidOrReservedQuote} title={labels[LabelKey.suggestedReservedQuote]} />
        )
      }
      isLoading={loadingQuote || (!selected && !quoteDraft && !setupError && !loadingQuoteError)}
      error={setupError || loadingQuoteError || paymentPageError}
    >
      {selected && quoteDraft && !loadingQuote && <QuoteDetails quote={selected.quoteData} quoteDraft={quoteDraft} />}
    </ErrorComponentWrapper>
  );
};

export default QuotePage;
